<template>
  <div class="poster">
    <div
      class="poster-container"
      id="canvas"
      :style="{
        position: 'relative',
        top: composeUrl ? 0 : '-1000px'
      }"
    >
      <img :src="composeUrl" v-if="composeUrl" class="compose-img">
      <template v-else>
        <img crossorigin="anonymous" :src="bgImg" class="bg">
        <div class="user-wrap">
          <div class="picture-wrap">
            <img crossorigin="anonymous" :src="avatarImg" v-if="avatarImg">
            <img crossorigin="anonymous" src="@/assets/avatar.png" v-else>
          </div>
          <span>{{ homeInfo.nickname }}</span>
        </div>
        <div id="qrcodeArea" ref="qrcodeArea">
          <img :src="qrcode" v-if="qrcode" >
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { fetchImage, toBase64, html2Img, composeQrcode, sleep } from './composeImg';
import { appid, env } from '@/config';
import { unlimitedQrCode } from '@/api';

export default {
  props: {
    shareConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      composeUrl: '',
      qrcode: '',
      bgImg: this.shareConfig.poster || '',
      avatarImg: this.homeInfo?.picture || ''
    };
  },
  computed: {
    ...mapState({
      homeInfo: state => state.share.homeInfo,
      shareUrl: state => state.share.shareUrl,
      pageData: state => state.share.pageData
    })
  },
  async mounted() {
    if (env !== 'mock' && !this.adapt.isLogin()) return;

    this.uploadData(this.$teleCodes.sharepop, 'event');

    try {
      if (!this.shareUrl || !this.shareConfig.poster) {
        await sleep(1000);
      }

      const [bgImg, avatarImg] = await Promise.all([
        await fetchImage(this.shareConfig.poster),
        await fetchImage(this.homeInfo.picture, { canFail: true })
      ]);

      this.bgImg = toBase64(bgImg);
      if (avatarImg) {
        this.avatarImg = toBase64(avatarImg);
      }

      // 根据设置，生成 h5 或 小程序二维码
      if (this.pageData.posterType === 'browser') {
        const qrcode = composeQrcode({ url: this.shareUrl });
        this.$refs.qrcodeArea.appendChild(qrcode);
      } else {
        await this.getUnlimitedQrCode();
      }

      this.$nextTick(() => {
        html2Img().then(res => {
          this.composeUrl = res;
          this.$emit('getImage', res);
        });
      });
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    async getUnlimitedQrCode() {
      const path = 'pages/common/webview';
      const req = {
        path,
        appId: appid,
        scene: `url=${encodeURIComponent(this.shareUrl)}`,
        width: 200
      };
      const res = await unlimitedQrCode(req);
      this.qrcode = res.base64Img
        ? `data:image/png;base64,${res.base64Img}`
        : '';
    }
  }
};
</script>

<style lang="less" scoped>
.poster {
  position: relative;

  .poster-container {
    position: relative;
    width: 240px;
    height: 384px;

    .compose-img {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 10px;
    }

    .bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      border-radius: 10px;
    }

    .user-wrap {
      position: absolute;
      z-index: 1;
      top: 32px;
      left: 16px;
      display: flex;

      .picture-wrap,
      img {
        display: block;
        width: 24px;
        height: 24px;
        border-radius: 12px;
      }

      span {
        margin-left: 6px;
        color: #fff;
      }
    }

    #qrcodeArea {
      position: absolute;
      z-index: 1;
      top: 160px;
      left: 50%;
      transform: translateX(-50%);

      img {
        display: block;
        width: 128px;
        height: 128px;
      }
    }
  }
}
</style>
